<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


document.addEventListener("DOMContentLoaded", function () {
        const faqContainer = document.getElementById("custom-faq-container");
        let openAnswer = null;

        faqContainer.addEventListener("click", function (e) {
          if (e.target.classList.contains("custom-faq-question")) {
            const answer = e.target.nextElementSibling;

            if (openAnswer && openAnswer !== answer) {
              openAnswer.classList.remove("open");
            }

            answer.classList.toggle("open");
            openAnswer = answer.classList.contains("open") ? answer : null;
          }
        });
      });